module.exports = __webpack_public_path__ + "media/customizations/harbourisle/logo-f1cc390d9649450af1bdc8adb03b66bf.png";